import historyAuthState from './state'
import historyAuthActions from './actions'
import historyAuthMutations from './mutations'
import historyAuthGetters from './getters'

export default {
  state () {
    return historyAuthState
  },
  actions: historyAuthActions,
  mutations: historyAuthMutations,
  getters: historyAuthGetters
}
